import React, { useRef } from 'react';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import CardDropdown from '@/components/common/CardDropdown';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardFooterLink from '@/components/common/FalconCardFooterLink';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getPosition, tooltipFormatter } from '@/helpers/echart-utils';
import {
  breakpointsMediaQuery,
  getColor,
  rgbaColor,
  useMediaQuery
} from '@/helpers/utils';
import CustomLegent from '@/app/common/components/charts/CustomLegent';
import { useTooltipHide } from '@/hooks/useTooltipHide';
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

const getOptions = (series, competitors, isMdUp) => ({
  textStyle: {
    fontFamily: 'dana'
  },
  legend: {
    show: false
    // data: ['رشد', 'افت', 'بدون تغییر'],
    // left: '0%',
    // icon: 'circle',
    // inactiveColor: getColor('gray-400'),
    // textStyle: { color: getColor('gray-700') },
    // itemGap: 10
  },
  yAxis: {
    type: 'category',
    data: competitors,
    axisLine: {
      show: false
    },
    boundaryGap: false,
    splitLine: {
      lineStyle: {
        color: getColor('gray-200')
      }
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      color: getColor('gray-600')
    }
  },
  xAxis: {
    type: 'value',
    splitLine: {
      lineStyle: {
        color: getColor('gray-200')
      }
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      show: false
    }
  },
  tooltip: {
    triggerOn: isMdUp ? 'mousemove' : 'click',
    trigger: 'axis',
    padding: [7, 10],
    axisPointer: {
      type: 'none'
    },
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('gray-1100') },
    borderWidth: 1,
    transitionDuration: 0,

    formatter: params => {
      let tooltipItem = ``;
      params.forEach(el => {
        tooltipItem =
          tooltipItem +
          `
            <div class="text-700 d-flex flex-row align-items-center justify-content-between w-100 gap-1">
              <span class="text-800 d-flex flex-row-reverse align-items-center gap-1">${el.seriesName?.toString()?.toPersianDigit()}${el.marker}</span>
              <span class="d-flex align-items-center gap-1">
               <span class="fw-bold text-1000">${el?.value?.toString()?.toPersianDigit()}</span>
              </span>
              </div>`;
      });
      return `<div class="d-flex flex-column align-items-end">
      <p class="mb-2 text-1000 fw-bold">${params[0].axisValue}</p>
      ${tooltipItem}
      </div>`;
    }
  },

  series,
  grid: {
    right: 5,
    left: 5,
    bottom: 10,
    top: 40,
    containLabel: true
  }
});
const GrowthAndDrops = ({ growth, drops, unchanged, competitors }) => {
  const cardRef = useRef();
  const chartRef = useRef();
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  const series = [
    {
      name: 'رشد',
      type: 'bar',
      stack: 'total',
      itemStyle: { color: getColor('success') },
      data: growth,
      barWidth: '20%'
    },
    {
      name: 'افت',
      type: 'bar',
      stack: 'total',
      itemStyle: { color: getColor('danger') },
      data: drops,
      barWidth: '20%'
    },
    {
      name: 'بدون تغییر',
      itemStyle: { color: getColor('secondary') },
      type: 'bar',
      stack: 'total',
      data: unchanged,
      barWidth: '20%'
    }
  ];
  return (
    <Card ref={cardRef} className="h-100">
      <FalconCardHeader
        title={
          <div>
            افت / رشد
            <HelpTooltip
              placement="top"
              html="نمودار زیر بر اساس بازه زمانی قابل تنظیم هست. (برای تغییر بازه زمانی، از گزینه‌های بالای صفحه استفاده کن.)"
            />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body className="pt-0 overflow-auto">
        <div className="d-flex align-items-center my-3 gap-3">
          {series?.map(item => (
            <CustomLegent
              key={item.name}
              name={item.name}
              chartRef={chartRef}
              color={item.itemStyle.color}
            />
          ))}
        </div>
        <ReactEChartsCore
          echarts={echarts}
          ref={chartRef}
          option={getOptions(series, competitors, isMdUp)}
          style={{ height: '19.1rem' }}
        />
      </Card.Body>

      {/* <FalconCardFooterLink title="View Details" size="sm" /> */}
    </Card>
  );
};

export default GrowthAndDrops;
